import { NetworkId, WalletId, WalletManager } from '@txnlab/use-wallet-react';

// Client-side wallet connector (replaces the old server-side WalletConnect v1
// flow that lived in the Node backend). Targets MainNet; supports Pera, Defly
// and Lute. use-wallet ships a working MainNet algod/genesis config, which is
// what the wallets need to sign MainNet transactions. The actual contract
// reads/sends go through the AlgorandClient configured in ./dispenser.js.
export const walletManager = new WalletManager({
  wallets: [
    WalletId.PERA,
    WalletId.DEFLY,
    {
      id: WalletId.LUTE,
      options: { siteName: "Is it Algorand's Birthday?" },
    },
  ],
  defaultNetwork: NetworkId.MAINNET,
});

export default walletManager;
